const STORAGE_KEY = 'intouch_schedule';

export const defaultSchedule = [
  {
    id: '1',
    time: '09:00 - 09:30',
    title: 'Arrival and Introduction',
    description: 'Shera-Lee Hambira / Desmarius Hansen',
    icon: 'UserCheck',
    type: 'logistics',
  },
  {
    id: '2',
    time: '09:30 - 09:45',
    title: 'My Zone in the past 11 years / Introducing Academy',
    description: 'Octavia Tsibes',
    icon: 'Activity',
    type: 'keynote',
  },
  {
    id: '3',
    time: '09:45 - 10:00',
    title: 'Technology & Media',
    description: 'Derick Briers',
    icon: 'Monitor',
    type: 'session',
    ctaUrl: 'https://derick.onwhats.app',
    ctaLabel: 'Connect on WhatsApp',
  },
  {
    id: '4',
    time: '10:00 - 10:20',
    title: 'Theme Introduction',
    description: 'Precious Nghitaunapo',
    icon: 'Star',
    type: 'session',
  },
  {
    id: '5',
    time: '10:20 - 10:30',
    title: 'Sponsor: Standard Bank',
    description: 'Supporting grassroots-level media involvement',
    icon: 'Briefcase',
    type: 'workshop',
  },
  {
    id: '6',
    time: '10:30 - 11:00',
    title: 'Closing Remarks / Thank You to Sponsors',
    description: 'Ludwig Helu',
    icon: 'Award',
    type: 'social',
  },
];

export const loadSchedule = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : defaultSchedule;
  } catch {
    return defaultSchedule;
  }
};

export const saveSchedule = (schedule) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(schedule));
};

export const resetSchedule = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const iconOptions = [
  'Activity', 'Award', 'Bell', 'Book', 'Bookmark', 'Briefcase',
  'Calendar', 'Camera', 'Clock', 'Code', 'Coffee', 'Compass',
  'Edit2', 'Eye', 'Flag', 'Globe', 'Heart', 'Home',
  'Info', 'Key', 'Layers', 'Link', 'Lock', 'Mail',
  'MapPin', 'Mic', 'Monitor', 'Moon', 'Music', 'Package',
  'Play', 'Settings', 'Shield', 'Smile', 'Star', 'Sun',
  'Tag', 'Terminal', 'ThumbsUp', 'Tool', 'TrendingUp',
  'User', 'UserCheck', 'Users', 'Video', 'Zap',
];

export const typeOptions = ['logistics', 'keynote', 'break', 'session', 'workshop', 'social'];
